/**
 * plekify-list-surface.js — T3 Phase 2a Map|List mode toggle (plekify.com, suffixed
 * country/region pages). Loaded by sections/plekify-travel-listing.liquid.
 *
 * Phase 2a contract (b):
 *   - Boot: read ?view= (map|list); explicit param wins, else trust the SSR'd body class.
 *     Default per template (doc 203 Phase 1, 2026-09-17): city/tourism_area SSR list-first,
 *     country/region/travel map-first — the server classes make first paint exact.
 *   - Toggle click: flip body class + history.replaceState -> ?view=map|list is a stable
 *     URL (the old ?view=map demotion redirect is REMOVED in travel-immersive-map.liquid).
 *   - Toggle click: flip body class + history.replaceState -> ?view=map|list is a stable
 *     URL (the old ?view=map demotion redirect is REMOVED in travel-immersive-map.liquid).
 *   - Hidden mode stays SSR'd and is hidden OFF-SCREEN by transform in
 *     plekify-list-surface.css (never display:none — display:none resets scrollTop and
 *     violates the scroll-preservation contract Phase 2b completes).
 *   - inert guard: the off-screen surface is made inert (focus/AT-proof) when hidden and
 *     un-inert when shown. Native `inert` (Chrome 102+/Safari 15.5+/FF 112+), no-op when
 *     unsupported. NOTE: hidden surfaces are ALSO aria-hidden free here — the CSS
 *     visibility:hidden already removes them from the AT tree.
 *
 * Buttons: any [data-plk-viewbtn] with value map|list — wired to the T2 shells
 * (plk-sub-bar desktop .plk-sb-view*, travel-immersive-map mobile pill
 * .plk-mapmode__viewtoggle-btn*) and the list-mode peek-map chip.
 */
(function () {
  'use strict';

  var LIST_CLASS = 'plk-mapmode--list';
  var SUPPORTS_INERT = 'inert' in document.documentElement;

  var mapSurf = document.querySelector('[data-plk-mapmode]');
  var listSurf = document.querySelector('[data-plk-listing]');
  var ovSurf = document.querySelector('[data-plk-destination-overview]');

  function setMode(mode, push) {
    var isList = mode === 'list';

    document.body.classList.toggle(LIST_CLASS, isList);

    // hidden = the OTHER surface (never display:none — CSS keeps it off-screen with
    // intact scrollTop). inert it so tabs/clicks can't land there.
    var hidden = isList ? mapSurf : [listSurf, ovSurf];
    var shown = isList ? [listSurf, ovSurf] : mapSurf;
    if (SUPPORTS_INERT) {
      (hidden && hidden.length ? hidden : [hidden]).forEach(function (el) {
        if (el) el.setAttribute('inert', '');
      });
      (shown && shown.length ? shown : [shown]).forEach(function (el) {
        if (el) el.removeAttribute('inert');
      });
    }

    // sync every view button shell (sub-bar desktop + map pill mobile + peek chip)
    var btn, i;
    var btns = document.querySelectorAll('[data-plk-viewbtn]');
    for (i = 0; i < btns.length; i++) {
      btn = btns[i];
      btn.setAttribute('aria-pressed', btn.getAttribute('data-plk-viewbtn') === mode ? 'true' : 'false');
    }

    if (push) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('view', mode);
        history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    try {
      document.dispatchEvent(new CustomEvent('plk:viewchange', { detail: { view: mode } }));
    } catch (e) {}
  }

  // boot from URL (fallback for JS-driven nav; the server class makes first paint exact).
  // doc 203 Phase 1 (2026-09-17): explicit ?view=map|list wins; a bare URL TRUSTS the
  // SSR'd body classes (city/tourism_area SSR list-first, country/region map-first).
  // Replaces the P2a force-map boot — its stale-cache adversary (old themes baking list
  // onto bare country URLs) long expired, and forcing map would strip the new list-first
  // SSR class off every destination page. Residual: a stale page_cache entry baked
  // pre-flip serves map-first until TTL expiry (degrades to prior behavior).
  var initial = null;
  try { initial = new URL(location.href).searchParams.get('view'); } catch (e) {}
  if (initial === 'map' || initial === 'list') setMode(initial, false);
  else setMode(document.body.classList.contains(LIST_CLASS) ? 'list' : 'map', false);

  // toggle clicks (delegated — covers both shells + the peek chip)
  document.addEventListener('click', function (e) {
    var t = e.target;
    while (t && t !== document) {
      if (t.getAttribute && t.getAttribute('data-plk-viewbtn')) break;
      t = t.parentNode;
    }
    if (!t || t === document) return;
    var mode = t.getAttribute('data-plk-viewbtn');
    if (mode !== 'map' && mode !== 'list') return;
    e.preventDefault();
    setMode(mode, true);
  });

  // ---------- doc 203 Phase 3: cross-document scroll anchor (2026-09-17) ----------
  // The locator strip's links (?view=map, ?view=map&focus=, chips) are FULL navigations.
  // The map|list flip keeps the document's own scrollTop, but nothing restores the reader's
  // place on the way BACK to the list surface. Write a one-shot sessionStorage anchor on any
  // view=map link click; restore it once, on the return load or on the flip back to list.
  // Stored SECTION-RELATIVE (marker + offset), never raw pixels: the map/list templates carry
  // the same surfaces MINUS the locator strip, so a pixel offset would land in the wrong place.
  var ANCHOR_KEY = 'plk-scroll-anchor';
  var ANCHOR_MARKS = ['data-plk-destination-overview', 'data-plk-locator', 'data-plk-listing', 'data-plk-mapmode'];

  function anchorSections() {
    var out = [];
    for (var i = 0; i < ANCHOR_MARKS.length; i++) {
      var els = document.querySelectorAll('[' + ANCHOR_MARKS[i] + ']');
      for (var j = 0; j < els.length; j++) out.push({ el: els[j], mark: ANCHOR_MARKS[i] });
    }
    return out;
  }

  function writeAnchor() {
    try {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var secs = anchorSections(), best = null;
      for (var i = 0; i < secs.length; i++) {
        var top = secs[i].el.getBoundingClientRect().top + y;
        if (top <= y + 1 && (!best || top > best.top)) best = { top: top, mark: secs[i].mark };
      }
      sessionStorage.setItem(ANCHOR_KEY, JSON.stringify({
        p: location.pathname,
        m: best ? best.mark : '',
        o: best ? Math.round(y - best.top) : 0,
        y: Math.round(y)
      }));
    } catch (e) {}
  }

  function restoreAnchorOnce() {
    if (!document.body.classList.contains(LIST_CLASS)) return; // the map surface owns the scroll
    if (location.search.indexOf('focus=') !== -1) return;      // an explicit deep link outranks it
    var raw = null;
    try { raw = sessionStorage.getItem(ANCHOR_KEY); } catch (e) { return; }
    if (!raw) return;
    try { sessionStorage.removeItem(ANCHOR_KEY); } catch (e) {} // one-shot: consume whatever happens next
    var a = null;
    try { a = JSON.parse(raw); } catch (e) { return; }
    if (!a || a.p !== location.pathname) return;
    var y = null;
    if (a.m) {
      var el = document.querySelector('[' + a.m + ']');
      if (el) y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) + (a.o || 0);
    }
    if (y === null && typeof a.y === 'number') y = a.y;
    if (y === null) return;
    window.scrollTo(0, y);
  }

  // writer: any link that navigates to the map surface
  document.addEventListener('click', function (e) {
    var t = e.target;
    while (t && t !== document) {
      if (t.tagName === 'A' && (t.getAttribute('href') || '').indexOf('view=map') !== -1) { writeAnchor(); return; }
      t = t.parentNode;
    }
  });

  // reader: on the return load, and on the flip back to the list surface
  if (document.readyState === 'complete') restoreAnchorOnce();
  else window.addEventListener('load', restoreAnchorOnce);
  document.addEventListener('plk:viewchange', function (e) {
    if (e && e.detail && e.detail.view === 'list') restoreAnchorOnce();
  });
})();
